import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { CVR_UPLOAD_READY_STATUSES, CVR_UPLOAD_COMPLETE_STATUSES } from "@/services/consts"
import getGroupResponse from '@/types/responses/getGroup';
import getVehicleResponse from '@/types/responses/getVehicle';
import getDepartmentResponse from '@/types/responses/getDepartment';
import SearchAndSortWindow from "@/components/CvrConvert/VehiclesListParts/SearchAndSortWindow.vue"
import cvrUploadSummariesData from "@/types/responses/cvrUploadSummariesData"
import { Ref, ref, computed } from 'vue';
import i18n from '@/lang/i18n'

type filteredItemsType = {
  vehicle: {key: number, value: boolean}[]
  department: {key: number, value: boolean}[]
  groups: {key: number, value: boolean}[]
  page: number
}

type itemsType = {
  vehicle: cvrUploadSummariesData[],
  department: getDepartmentResponse[],
  groups: getGroupResponse[]
}

const VEHICLE_KEY = 'vehicle'
const DEPARTMENT_KEY = 'department'
const GROUP_KEY = 'groups'
const UPLOAD_STATUS_KEY = 'upload_statuses'

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchAttributeContents',
  props: {
    modelValue: {},
    windowKey: {},
    sortKey: {},
    sortType: {},
    width: {},
    items: {},
    label: {},
    filteredItems: {},
    summariesList: {},
    searchedKeys: {}
  },
  emits: ['update:modelValue', 'changeSortType', 'closeWindow', 'search', 'setIsAllSelected'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const filterText: Ref<string> = ref('')

const SELECTABLE_UPLOAD_STATUSES = [
  {key: 'ready', value: i18n.global.t('pages.cvr_uploads.waitting')},
  {key: 'completed', value: i18n.global.t('pages.cvr_uploads.requestAvailable')}
]

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

const isUploadStatusKey = computed(() => (keyName: string) =>{
  return keyName == UPLOAD_STATUS_KEY
})

const selectableItems = computed(() => {
  if (isUploadStatusKey.value(props.windowKey)) return []
  let responseItems: any[] = checkSearchedItems()
  if (!filterText.value) return responseItems
  return responseItems.filter((item: any) => {
    if (props.windowKey == VEHICLE_KEY) {
      return item.number_plate.includes(filterText.value)
    }
    return item.name.includes(filterText.value)
  })
})

const isUploadStatusAllSelected = computed(() => {
  if (!Array.isArray(modelValue.value)) {
    return false;
  }
  return SELECTABLE_UPLOAD_STATUSES.every((status) =>
    modelValue.value.some((selected: { key: string, value: string } | null) => selected && selected.key === status.key)
  );
})

const candidateLabel = computed(() => {
  if (props.windowKey == VEHICLE_KEY) return 'number_plate'
  return 'name'
})

function checkSearchedItems() {
  if (!props.searchedKeys.length || props.searchedKeys[0] == props.windowKey) return props.items[props.windowKey]
  let checkedItems: any[] = []
  let filteredSummaries: cvrUploadSummariesData[] = []

  props.searchedKeys.forEach((searchedKey: string, index: number) => {
    props.filteredItems[searchedKey].forEach((filteredItem: boolean | null | {key: string, value: string}, filteredItemId: number) => {
      if (!filteredItem) return
      const originFilterList: cvrUploadSummariesData[] = index === 0 ? props.summariesList : JSON.parse(JSON.stringify(filteredSummaries))
      const findedSummaries: cvrUploadSummariesData[] | undefined = originFilterList.filter((summary: cvrUploadSummariesData) => {
        if (searchedKey == VEHICLE_KEY) return seachVehicle(summary, filteredItemId)
        if (searchedKey == DEPARTMENT_KEY) return searchDepartment(summary, filteredItemId)
        if (searchedKey == GROUP_KEY) return searchGroup(summary, filteredItemId)
        if (isUploadStatusKey.value(searchedKey)) return searchUploadStatue(summary, filteredItem)
      })

      if (index === 0 && props.searchedKeys.length > 1) return filteredSummaries.push(...findedSummaries)

      findedSummaries.forEach((summary: cvrUploadSummariesData) => {
        let addItems: any[] = []
        let addItem: any
        if (props.windowKey == GROUP_KEY) {
          addItems = makeAddItemsByGroup(summary, 'group_names', 'name')
        } else if (props.windowKey == DEPARTMENT_KEY) {
          addItem = makeAddItem(summary, 'department_name', 'name')
          if (addItem) addItems.push(addItem)
        } else if (props.windowKey == VEHICLE_KEY) {
          addItem = makeAddItem(summary, 'number_plate', 'number_plate')
          if (addItem) addItems.push(addItem)
        }
        if (!addItems.length) {
          if (!checkedItems.includes(props.items[props.windowKey][0])) checkedItems.unshift(props.items[props.windowKey][0])
          return
        }
        checkedItems.push(...addItems)
      })
    })
  })
  return Array.from(new Set(checkedItems));
}

function makeAddItem(summary: cvrUploadSummariesData, summaryKeyName: string, keyName: string) {
  const filteredIndex = props.items[props.windowKey].findIndex((item: any) => {
    return item[keyName] == summary[summaryKeyName]
  })
  if (filteredIndex != -1) return props.items[props.windowKey][filteredIndex]
}

function makeAddItemsByGroup(summary: cvrUploadSummariesData, summaryKeyName: string, keyName: string) {
  const filteredIds: number[] = []
  props.items[props.windowKey].forEach((item: any, id: number) => {
    if (summary[summaryKeyName].includes(item[keyName])) filteredIds.push(id)
  })

  let groups: getGroupResponse[] = []
  filteredIds.forEach((filteredId: number) => {
    groups.push(props.items[props.windowKey][filteredId])
  })
  return groups
}

function seachVehicle(summary: cvrUploadSummariesData, filteredItemId: number) {
  return props.items[VEHICLE_KEY].find((vehicle: getVehicleResponse) => {
    if (vehicle.id == filteredItemId && vehicle.number_plate == summary.number_plate) {
      return summary
    }
  })
}

function searchDepartment(summary: cvrUploadSummariesData, filteredItemId: number) {
  if (props.filteredItems[DEPARTMENT_KEY][0] && !summary.department_id) return summary
  if (summary.department_id == filteredItemId) return summary
}

function searchGroup(summary: cvrUploadSummariesData, filteredItemId: number) {
  if (props.filteredItems[GROUP_KEY][0] && !summary.group_ids.length) return summary
  if (summary.group_ids.includes(filteredItemId)) return summary
}

function searchUploadStatue(summary: cvrUploadSummariesData, filteredItem: any) {
  if (filteredItem.key == 'ready') {
    if (CVR_UPLOAD_READY_STATUSES.includes(summary.latest_status)) return summary
  }
  if (filteredItem.key == 'completed') {
    if (CVR_UPLOAD_COMPLETE_STATUSES.includes(summary.latest_status)) return summary
  }
}

function setSelectAll(status: boolean, key: string) {
  if (isUploadStatusKey.value(key)) return setSelectAllUploadStatus(status)
  selectableItems.value.forEach((value: any) => {
    modelValue.value[value.id] = status
  })
}

function setIsAllSelected($event: { windowKey: string, isAllSelected: boolean }) {
  if ($event.windowKey == UPLOAD_STATUS_KEY) {
    $event.isAllSelected = isUploadStatusAllSelected.value;
  }
  emits('setIsAllSelected', $event)
}

function setSelectAllUploadStatus(status: boolean) {
  if (status) return modelValue.value = SELECTABLE_UPLOAD_STATUSES
  modelValue.value = []
}

function changeSortType(type: string) {
  emits('changeSortType', type)
}

function closeWindow(status: boolean) {
  emits('closeWindow', status)
}

function search() {
  emits('search', props.windowKey)
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(SearchAndSortWindow, {
    width: props.width,
    sortType: props.sortType,
    items: selectableItems.value,
    windowKey: props.windowKey,
    sortKey: props.sortKey,
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modelValue).value = $event)),
    candidateLabel: candidateLabel.value,
    onChangeSortType: changeSortType,
    onClose: closeWindow,
    onSetSelect: setSelectAll,
    onSearch: search,
    onSetIsAllSelected: setIsAllSelected
  }, {
    default: _withCtx(() => [
      (isUploadStatusKey.value(props.windowKey))
        ? (_openBlock(), _createBlock(_component_v_select, _mergeProps({
            key: 0,
            modelValue: modelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
            items: SELECTABLE_UPLOAD_STATUSES,
            "item-value": "key",
            "item-title": "value",
            "hide-details": "auto",
            class: "select-box",
            multiple: ""
          }, {'return-object': true}), null, 16, ["modelValue"]))
        : (_openBlock(), _createBlock(_component_v_text_field, {
            key: 1,
            class: "my-2",
            label: props.label,
            modelValue: filterText.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterText).value = $event))
          }, null, 8, ["label", "modelValue"]))
    ]),
    _: 1
  }, 8, ["width", "sortType", "items", "windowKey", "sortKey", "modelValue", "candidateLabel"]))
}
}

})